import { CustomIcon } from 'modules/components/layer00';
import { InformationModalLayout } from 'modules/components/layer13';
import React from 'react';
import * as ds from './dataService';



export type DuplicateFolderModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: DuplicateFolderModalProps) => {
  const [
    fnDuplicateFolder,
    { loading }
  ] = ds.useDuplicateFolder();

  return (
    <InformationModalLayout.FC
      id={props.id}
      isVisible={props.isVisible}
      loading={loading}
      handleClose={() => props.handleClose()}
      title='Duplicate Folder'
      headerIcon={(
        <CustomIcon.large.FC
          icon='DELETE'
        />
      )}
      subTitle='Are you sure to duplicate folder? This action cannot be undone.'
      successButton={{
        text: 'Confirm',
        handleClick: async () => {
          await fnDuplicateFolder(props.id);
          props.handleClose();

        }
      }}
      cancelButton={{
        text: 'Cancel',
        handleClick: () => props.handleClose()
      }}
    />
  );
};
